var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('Loading'):(_vm.error)?_c('Error',{attrs:{"error":_vm.error}}):_c('div',{attrs:{"id":"body-container"}},[_c('Map',{attrs:{"actions":_vm.actionsWithinGroupBounds}}),_vm._v(" "),_c('PageContainer',[_c('Actions',{attrs:{"actions":_vm.actions,"sectors":_vm.sectors,"types":_vm.types}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }